const PortletEvent = {
  CONFIG_CLICKED: 'portletConfigClicked',
  CONFIG_SAVED: 'portletConfigSaved',
  DRAG_STARTED: 'portletDragStarted',
  DRAG_STOPPED: 'portletDragStopped',
  RESIZE_STOPPED: 'portletResizeStopped', // This event is triggered at the end of a resize operation.
  RESIZED: 'portletResized', // This event is triggered during the resize, on the drag of the resize handler.
  MAXIMIZED: 'portletMaximized',
  MINIMIZED: 'portletMinimized',
  DESTROYED: 'onDestroy',
};

export default PortletEvent;
